import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall3StepCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m5 9.208 2.1 2.125L12 5.667"
    />
  </svg>
);
export default SvgPaywall3StepCheck;
